<template>
  <div id="dashCarreira">
    <BreadSistema />
    <div class="container d-flex align-items-center justify-content-center">
      <div class="card p-4">
        <form class="row" @submit.prevent="sendEmail">
          <div class="col-12">
            <b-form-input type="email" v-model="email" placeholder="Seu Email" size="sm" required />
          </div>
          <div class="col-12 mt-2">
            <b-form-input type="text" size="sm" v-model="nome" placeholder="Seu nome" required />
          </div>
          <div class="col-12 mt-2">
            <b-form-file type="file" @change="onFileChange" required placeholder="Nenhum arquivo foi selecionado" />
          </div>
          <div class="col-12 mt-4">
            <div class="text- ">
              <button type="submit" class="btn shadow-none btn-primary" style="font-size: 14px;">Enviar</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <form @submit.prevent="sendEmail">

      <br>




      <br>



    </form>
  </div>
</template>

<script>
import ApiService from '../../../common/api.service';
export default {
  name: 'simples-trabalhe-conosco',
  metaInfo: { title: 'Trabalhe Conosco' },
  components: { BreadSistema: () => import('@/components/GlobalComponents/bread-sistema.vue') },
  data() {
    return {
      email: '',
      attachment: null,
      nome: ''
    };
  },
  methods: {
    onFileChange(event) {
      this.attachment = event.target.files[0];
    },
    async sendEmail() {

      const formData = new FormData();
      formData.append('email', this.email);
      formData.append('attachment', this.attachment);
      formData.append('nome', this.nome);
      try {

        await ApiService.post('/v1/send-email', formData);
        alert('Email sent successfully!');
      } catch (error) {
        console.error('Error sending email:', error);
        alert('Failed to send email.');
      }
    }
  }
};
</script>

<style scoped>
#dashCarreira {
  margin: 88px 0px 0px;
}

@media only screen and (min-width: 1920px) {
  .card {
    width: 50%;
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1920px) {
  .card {
    width: 50%;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1280px) {
  .card {
    width: 50%;
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .card {
    width: 100%;
  }
}

@media only screen and (min-width: 576px) and (max-width: 768px) {
  .card {
    width: 100%;
  }
}

@media only screen and (min-width: 320px) and (max-width: 576px) {
  .card {
    width: 100%;
  }
}
</style>
